/**
 * Conversion between a native `<input type="datetime-local">`'s value
 * (always expressed in the BROWSER'S local timezone, no offset) and the
 * ISO-8601-with-timezone string `couponInputSchema`'s `.datetime()` actually
 * requires. No existing form in this app handles a datetime field yet
 * (`ProductForm` only has plain numbers/selects), so this is new — built
 * from `Date`'s own local-component getters, never by slicing the ISO
 * string, which would silently mislabel a UTC instant as local time.
 */

/** ISO datetime (or null) → `datetime-local` input value ('' when null). */
export function isoToDatetimeLocal(iso: string | null): string {
  if (iso === null) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (n: number): string => String(n).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${String(year)}-${month}-${day}T${hours}:${minutes}`;
}

/** `datetime-local` input value ('' meaning unset) → ISO datetime or null. */
export function datetimeLocalToIso(value: string): string | null {
  if (value === '') return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}
